import { render, staticRenderFns } from "./DashMain.vue?vue&type=template&id=17466cf3&scoped=true&lang=true&"
import script from "./DashMain.vue?vue&type=script&lang=js&"
export * from "./DashMain.vue?vue&type=script&lang=js&"
import style0 from "./DashMain.vue?vue&type=style&index=0&id=17466cf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17466cf3",
  null
  
)

export default component.exports